
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetomahabaleshwarcabs() {



  const cardData =
  {
    keyword: ' Pune to Mahabaleshwar Cabs',
    heading: 'Vaishnavi Travels: Pune to Mahabaleshwar Cabs',
    headingDescription: 'Vaishnavi Travels offers comfortable and affordable Pune to Mahabaleshwar Cabs, perfect for family vacations, weekend getaways, corporate outings, and group tours. Our cabs are well-maintained with spacious seating, strong air-conditioning, and ample luggage capacity, ensuring a smooth and enjoyable ride through the scenic Pune–Mahabaleshwar route. With professional chauffeurs, timely pickups, and flexible booking options, we make your hill station trip convenient and stress-free. Whether it’s a short holiday, honeymoon, or leisure tour, Vaishnavi Travels guarantees safe, reliable, and comfortable cab services from Pune to Mahabaleshwar.',

    top: 'Top Places to Visit in Mahabaleshwar with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake, built in 1842, is Mahabaleshwar’s most popular attraction, surrounded by lush greenery and hills. Tourists enjoy paddle boating, row boating, and horse rides along the lakeside. Street stalls serving hot corn, strawberries, and local snacks make it lively. The cool breeze and scenic backdrop make evenings here magical. Families and couples love its peaceful charm. Venna Lake is Mahabaleshwar’s vibrant hub of leisure and beauty."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat, called the ‘Queen of Points,’ is Mahabaleshwar’s most famous viewpoint. From here, tourists admire the deep Savitri gorge and surrounding valleys. The spot is known for its unique phenomenon where light objects float upward due to air pressure. Sunrise and sunset views are breathtaking from this cliff. Trekkers and photographers especially enjoy this scenic point. Arthur’s Seat is Mahabaleshwar’s iconic viewpoint of wonder and natural beauty."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a delightful stop in Mahabaleshwar known for strawberries and fruit products. Visitors enjoy fresh strawberry shakes, ice creams, and pizzas with a unique twist. The garden has a chocolate factory, nursery, and play area for kids. During the Strawberry Festival, the place comes alive with music and unlimited tastings. Families love shopping for jams, syrups, and juices here. Mapro Garden is Mahabaleshwar’s sweet paradise of flavors."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, built by Chhatrapati Shivaji Maharaj in 1656, is a historic landmark near Mahabaleshwar. It is famous for the battle where Shivaji defeated Afzal Khan. The fort has temples, bastions, and monuments dedicated to Maratha warriors. From the top, tourists enjoy breathtaking views of the Konkan plains. Trekkers find it an exciting destination blending history and adventure. Pratapgad Fort is Mahabaleshwar’s proud symbol of Maratha valor."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a natural rock formation that resembles an elephant’s trunk. It offers panoramic views of the Sahyadri ranges and valleys. The spot is popular for photography, especially at sunrise and sunset. Couples and nature lovers enjoy its peaceful environment. Monsoon adds mist and dramatic beauty to the view. Elephant’s Head Point is Mahabaleshwar’s natural wonder carved by time."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall, located near Mahabaleshwar, cascades from a height of 600 feet, creating a majestic sight. Surrounded by dense forests, it is especially stunning during monsoon. Tourists can view the main fall from a distance or enjoy smaller falls nearby for close interaction. The area is popular for trekking and photography. The cool mist and greenery make it refreshing. Lingmala Waterfall is Mahabaleshwar’s monsoon paradise."
  },
  {
    "title": "Wilson Point",
    "description": "Wilson Point, the highest point in Mahabaleshwar at 1,439 meters, is famous for sunrise views. It has three watchtowers offering 360-degree views of the hills and valleys. Tourists gather early morning to watch the sun rising over the Sahyadris. The open landscapes also make it ideal for stargazing at night. Its peaceful environment attracts nature lovers. Wilson Point is Mahabaleshwar’s crown for breathtaking vistas."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "The Mahabaleshwar Temple, built in the 16th century, is dedicated to Lord Shiva. It houses a swayambhu shivling believed to be self-manifested. The temple’s simple stone architecture radiates spiritual power. Pilgrims visit year-round, especially during Shivratri. The peaceful surroundings make it ideal for meditation. Mahabaleshwar Temple is the town’s spiritual and historic soul."
  },
  {
    "title": "Panchganga Temple",
    "description": "Panchganga Temple is believed to be the origin of five rivers – Krishna, Venna, Savitri, Koyna, and Gayatri. Built by the Yadava rulers and later renovated by the Marathas, it is a sacred pilgrimage site. Pilgrims take blessings at the confluence of the holy streams. The temple’s stone architecture and peaceful environment attract both devotees and tourists. Monsoon enhances the beauty of the surroundings. Panchganga Temple is Mahabaleshwar’s sacred riverside shrine."
  },
  {
    "title": "Tapola (Mini Kashmir)",
    "description": "Tapola, known as ‘Mini Kashmir,’ is a small village near Mahabaleshwar famous for the Shivsagar Lake backwaters. Tourists enjoy boating, kayaking, and camping by the lake. Surrounded by hills and greenery, it is a paradise for nature lovers. Trekkers use Tapola as a base for trails into the Sahyadris. Its untouched beauty makes it a hidden gem. Tapola is Mahabaleshwar’s offbeat escape of peace and adventure."
  }
],


           "services": [
    {
      "name": "Pune Mahabaleshwar Cab Booking",
      "description": "Book reliable and comfortable cabs from Pune to Mahabaleshwar for solo travelers, families, and groups. Our service offers flexible booking options including one-way and round trips, ensuring a hassle-free journey to the scenic hill station. Vehicles are well-maintained with professional drivers to guarantee a safe and timely trip."
    },
    {
      "name": "AC Taxi Pune to Mahabaleshwar",
      "description": "Travel in cool comfort with our air-conditioned taxi service from Pune to Mahabaleshwar. Perfect for long drives, these cabs provide a refreshing environment with efficient AC systems, plush interiors, and smooth rides. Ideal for families, corporate travelers, and tourists seeking a pleasant hill station journey."
    },
    {
      "name": "Round Trip Cab Mahabaleshwar",
      "description": "Convenient round trip cab services between Pune and Mahabaleshwar that allow you to explore the hill station at your own pace. Enjoy flexible pick-up and drop-off timings, stops at key viewpoints, and comfortable travel with trusted drivers experienced on these routes."
    },
    {
      "name": "One Way Cab Mahabaleshwar",
      "description": "Affordable one way cab rentals from Pune to Mahabaleshwar or vice versa. Ideal for travelers with onward plans or drop-offs at different locations. Book your taxi with ease and benefit from transparent pricing, courteous drivers, and safe journeys."
    },
    {
      "name": "Budget Cab Pune Mahabaleshwar",
      "description": "Cost-effective and reliable budget taxi services from Pune to Mahabaleshwar, suited for solo travelers or groups looking to save on transportation without compromising safety and comfort. Our fleet includes well-maintained vehicles offering basic amenities at competitive prices."
    },
    {
      "name": "SUV Cab to Mahabaleshwar",
      "description": "Premium SUV cab rentals for Pune to Mahabaleshwar trips, providing extra space, rugged comfort, and superior road handling. Perfect for family trips, group travel, or those who prefer enhanced comfort and style during hill station visits."
    },
    {
      "name": "Family Trip Cab Pune to Mahabaleshwar",
      "description": "Tailored cab services for family trips from Pune to Mahabaleshwar, ensuring safety, convenience, and a comfortable ride. Vehicles are spacious and drivers courteous, helping families enjoy their hill station vacations without transport worries."
    },
    {
      "name": "Corporate Mahabaleshwar Cab",
      "description": "Professional cab services designed for corporate travelers heading to Mahabaleshwar from Pune. Reliable, punctual, and discreet transportation with options for AC, SUV, and luxury vehicles to suit business trips, team outings, or corporate retreats."
    },
    {
      "name": "Online Cab Booking Mahabaleshwar",
      "description": "Easy and secure online booking platform for cabs from Pune to Mahabaleshwar. Choose your vehicle, schedule your trip, and get instant confirmation along with 24/7 customer support to ensure a smooth booking experience."
    },
    {
      "name": "Scenic Drive Mahabaleshwar Cab",
      "description": "Enjoy the beautiful landscapes and winding roads of Maharashtra with our scenic drive cab services to Mahabaleshwar. Our drivers know the best routes and viewpoints, making your journey as memorable as the destination itself."
    },
    {
      "name": "24×7 Cab Service Mahabaleshwar",
      "description": "Round-the-clock taxi services available for Pune to Mahabaleshwar travel. Whether it’s an early morning departure or a late-night arrival, our cabs and drivers are ready anytime to cater to your travel needs with promptness and professionalism."
    },
    {
      "name": "Cab Fare Pune to Mahabaleshwar",
      "description": "Transparent and competitive cab fare options for travel between Pune and Mahabaleshwar. We provide detailed fare estimates, including taxes, tolls, and driver allowances, ensuring no hidden costs and easy budget planning for your trip."
    },
    {
      "name": "Pilgrimage Mahabaleshwar Cab",
      "description": "Specialized cab services catering to pilgrimage travelers heading to Mahabaleshwar temples and religious sites. Comfortable and respectful transportation with knowledgeable drivers who can assist in planning your spiritual journey."
    }
  ],
  "tableData": [
    ["Pune Mahabaleshwar Cab Booking", "AC Taxi Pune to Mahabaleshwar"],
    ["Round Trip Cab Mahabaleshwar", "One Way Cab Mahabaleshwar"],
    ["Budget Cab Pune Mahabaleshwar", "SUV Cab to Mahabaleshwar"],
    ["Family Trip Cab Pune to Mahabaleshwar", "Corporate Mahabaleshwar Cab"],
    ["Online Cab Booking Mahabaleshwar", "Scenic Drive Mahabaleshwar Cab"],
    ["24×7 Cab Service Mahabaleshwar", "Cab Fare Pune to Mahabaleshwar"],
    ["Pilgrimage Mahabaleshwar Cab"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mahabaleshwar Cabs",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable cab services from Pune to Mahabaleshwar, perfect for weekend getaways, family trips, and group outings."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles Available",
    "WhyChoosedescription": "Choose from Swift Dzire, Ertiga, Innova, Urbania, and Tempo Traveller based on your group size and comfort preferences."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our cabs are regularly serviced and thoroughly cleaned to ensure safety and hygiene throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Mahabaleshwar for a smooth and timely travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer all-inclusive pricing covering fuel, tolls, parking, and driver allowance with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy convenient door-to-door service from your home, hotel, or office in Pune and drop-off at your preferred destination in Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Ideal for Leisure Trips and Group Tours",
    "WhyChoosedescription": "Perfect for families, friends, and corporate groups looking to explore the scenic beauty of Mahabaleshwar."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist you with bookings, itinerary planning, and travel inquiries."
  }
]

















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide cab services from Pune to Mahabaleshwar?',
      answer: 'Yes, Vaishnavi Travels offers comfortable and reliable cab services from Pune to Mahabaleshwar, perfect for family trips, weekend getaways, and sightseeing tours.',
    },
    {
      question: 'What types of cabs are available for the Pune to Mahabaleshwar route?',
      answer: 'We offer a range of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Travellers to suit different group sizes and travel preferences.',
    },
    {
      question: 'Are the drivers experienced with the Pune to Mahabaleshwar route?',
      answer: 'Absolutely! Our drivers are well-trained and familiar with the hilly terrain and winding roads of Mahabaleshwar to ensure a safe and smooth journey.',
    },
    {
      question: 'What is the typical fare for a cab from Pune to Mahabaleshwar?',
      answer: 'Fares generally start from ₹3,500 for a one-way trip in a sedan like Swift Dzire. Rates vary based on vehicle type, trip duration, and return options.',
    },
    {
      question: 'Can I book a round trip cab from Pune to Mahabaleshwar?',
      answer: 'Yes, we offer flexible round trip packages for same-day or multi-day stays with transparent pricing and customizable itineraries.',
    },
    {
      question: 'How far in advance should I book a Pune to Mahabaleshwar cab?',
      answer: 'It is recommended to book at least 1-2 days in advance, especially during weekends and holiday seasons to ensure vehicle availability.',
    },
    {
      question: 'Is doorstep pickup and drop-off available for Pune to Mahabaleshwar cabs?',
      answer: 'Yes, Vaishnavi Travels provides convenient doorstep pickup and drop-off services anywhere in Pune and nearby areas.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rahul Deshmukh",
    position: "Travel Blogger",
    feedback:
      "Vaishnavi Travels made our Pune to Mahabaleshwar trip hassle-free and enjoyable. The cab was comfortable, and the driver was friendly and knowledgeable.",
    rating: 5,
  },
  {
    name: "Ms. Anjali Patil",
    position: "Tourist",
    feedback:
      "Great experience with Vaishnavi Travels for Mahabaleshwar cab service. Timely pickup, clean vehicle, and smooth ride through the hills. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];












































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Mahabaleshwar Cabs",
  "description": "Book AC and Non-AC cabs from Pune to Mahabaleshwar for round trips, one-way rides, family trips, corporate travel, and pilgrimage tours. Affordable and reliable cab service available 24x7.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "areaServed": "Pune",
    "url": "https://vaishnavitravel.com/pune-to-mahabaleshwar-cab"
  },
  "serviceType": "Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Cab Services Pune to Mahabaleshwar",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Taxi",
          "name": "AC Cab Pune to Mahabaleshwar"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Taxi",
          "name": "Non-AC Cab Pune to Mahabaleshwar"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Taxi",
          "name": "SUV Cab Pune to Mahabaleshwar"
        }
      }
    ]
  },
  "url": "https://vaishnavitravel.com/pune-to-mahabaleshwar-cab"
};




  return (
    <div>

<Helmet>
  <title>Pune to Mahabaleshwar Cabs | AC & Non-AC Taxi Service</title>
  <meta
    name="description"
    content="Book AC and Non-AC cabs from Pune to Mahabaleshwar for round trips, one-way rides, family trips, corporate travel, and pilgrimage tours. Affordable and reliable cab service available 24x7."
  />
  <meta
    name="keywords"
    content="Pune Mahabaleshwar Cab Booking, AC Taxi Pune to Mahabaleshwar, Round Trip Cab Mahabaleshwar, One Way Cab Mahabaleshwar, Budget Cab Pune Mahabaleshwar, SUV Cab to Mahabaleshwar, Family Trip Cab Pune to Mahabaleshwar, Corporate Mahabaleshwar Cab, Online Cab Booking Mahabaleshwar, Scenic Drive Mahabaleshwar Cab, 24x7 Cab Service Mahabaleshwar, Cab Fare Pune to Mahabaleshwar, Pilgrimage Mahabaleshwar Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwarcabs;